import { switchAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const switchSlotRecipe = defineSlotRecipe({
  slots: switchAnatomy.keys(),
  className: 'switch',
  base: {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8',
      '--switch-diff': 'calc(var(--switch-width) - var(--switch-height))',
      '--switch-x': {
        base: 'var(--switch-diff)',
        _rtl: 'calc(var(--switch-diff) * -1)',
      },
    },

    label: {
      _disabled: {
        color: 'text/disabled',
      },
    },

    indicator: {
      color: 'icon/on-color',
      position: 'absolute',
      width: 'var(--switch-height)',
      height: 'var(--switch-height)',
      display: 'grid',
      placeContent: 'center',
      userSelect: 'none',
      insetInlineStart: 'calc(var(--switch-x) - 2px)',
      _checked: {
        insetInlineStart: '2',
      },
    },

    control: {
      position: 'relative',
      display: 'inline-flex',
      width: 'var(--switch-width)',
      height: 'var(--switch-height)',
      bg: 'input/switch/off/track',
      cursor: 'pointer',
      transition: 'backgrounds',
      _checked: {
        bg: 'input/switch/on/track',
        _disabled: {
          bg: 'input/switch/on/track-disabled',
        },
      },
      _disabled: {
        bg: 'input/switch/off/track-disabled',
        cursor: 'not-allowed',
      },
      _readOnly: {
        cursor: 'default',
      },
      focusVisibleRing: 'outside',
    },

    thumb: {
      width: 'var(--switch-height)',
      height: 'var(--switch-height)',
      bg: 'input/switch/off/thumb',
      boxShadow: 'elevation/sm',
      scale: '0.8',
      borderRadius: 'inherit',
      transitionProperty: 'translate',
      transitionDuration: 'fast',
      _checked: {
        bg: 'input/switch/on/thumb',
        translate: 'var(--switch-x) 0',
      },
      _disabled: {
        bg: 'input/switch/off/thumb-disabled',
        _checked: {
          bg: 'input/switch/on/thumb-disabled',
        },
      },
    },
  },

  variants: {
    size: {
      md: {
        root: {
          '--switch-width': rem(32),
          '--switch-height': rem(16),
          '--switch-indicator-font-size': rem(12),
        },
        control: {
          borderRadius: '8',
        },
        label: {
          textStyle: 'body/md/regular',
        },
      },
      lg: {
        root: {
          '--switch-width': rem(48),
          '--switch-height': rem(24),
          '--switch-indicator-font-size': rem(16),
        },
        control: {
          borderRadius: '12',
        },
        label: {
          textStyle: 'body/lg/regular',
        },
      },
    },
  },

  defaultVariants: {
    size: 'lg',
  },
});

export default switchSlotRecipe;
